// extracted by mini-css-extract-plugin
module.exports = {"link":"bread-crumbs-module__link___M+I-K","divider":"bread-crumbs-module__divider___nBtwC","activeLink":"bread-crumbs-module__activeLink___kmFfO"};